module.exports = __webpack_public_path__ + "qa.11d998f57da5ffb8847d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/qa.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/qa.svg
// module chunks = styles